import {Component} from "@angular/core";
import {AuthApiService} from "../../auth/auth-api.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ErrorHandlerService} from "../../../error-handler.service";
import {FUISpinnersService} from "@fedelta-pos/ui";
import {Router} from "@angular/router";
import {PartnerData} from "../partner.data";
import {BehaviorSubject, catchError} from "rxjs";
import {HttpClient} from "@angular/common/http";

@Component({
    selector: "fhm-partner-edit-page",
    styles: [":host {display: flex; width: 100%;}"],
    templateUrl: "./partner-edit-page.component.html",
    standalone: false
})
export class PartnerEditPageComponent {

    name: string;

    public formGroup: FormGroup;

    constructor(
        private http: HttpClient,
        private auth: AuthApiService,
        private errorHandler: ErrorHandlerService,
        private spinnersService: FUISpinnersService,
        private router: Router,
        private formBuilder: FormBuilder) {

        this.formGroup = this.formBuilder.group({
            name: ["", Validators.required]
        });

        this.formGroup.get("name")["required$"] = new BehaviorSubject(true);
    }

    done(): void {
        this.router.navigate(["/main/partner-search"]);
    }

    save(): void {
        Object.keys((this.formGroup.controls)).forEach((key) => {
            this.formGroup.controls[key].markAsTouched();
            this.formGroup.controls[key].updateValueAndValidity();
        });
        if (this.formGroup.status === "VALID") {
            const partner: PartnerData = new PartnerData();
            partner.name = this.name;
            this.spinnersService.open();

            this.http.post<void>("/fonzie/partner", partner, {headers: this.auth.getHttpHeaderOptions()})
                .pipe(catchError((error) => {
                    return this.errorHandler.handleError(error);
                }))
                .subscribe(() => {
                    this.spinnersService.close();
                    this.done();
                });
        } else {
            console.log("Not valid  " + this.formGroup.status);
        }
    }

}
